import {
  Button,
  Popup,
  Swipe,
  SwipeItem,
  Tag,
  Divider,
  Tab,
  Tabs,
  Col,
  Row,
  Icon,
  Dialog,
  Lazyload,
  ImagePreview,
  NavBar,
  Tabbar,
  TabbarItem ,
  Toast 
} from "vant";

const vant = {
  install: function (Vue) {
    Vue.use(Button);
    Vue.use(Popup);
    Vue.use(Swipe);
    Vue.use(SwipeItem);
    Vue.use(Tag);
    Vue.use(Divider);
    Vue.use(Tab);
    Vue.use(Tabs);
    Vue.use(Col);
    Vue.use(Row);
    Vue.use(Icon);
    Vue.use(NavBar);
    Vue.use(Tabbar);
    Vue.use(TabbarItem);
    Vue.use(Toast);
    Vue.use(Lazyload, {
      lazyComponent: true,
    });
    Vue.use(Dialog);
  },
};

export default vant;
